<template>
	<div class="blTabHeaderContainer">
		<slot></slot>
		<div v-if="notification !== false" class="blTabHeaderContainerNotification">{{ notification === true ? '' : notification }}</div>
	</div>
</template>

<script>
export default {
	name: 'BlTabHeader',
	props: {
		notification: {
			type: [Number, Boolean],
			default: false
		}
	},
	inject: ['blTabUpdateHeaderTab'],
	mounted() {
		this.observer = new MutationObserver(() => this.blTabUpdateHeaderTab())

		this.observer.observe(this.$el, {attributes: true, childList: true, characterData: true, subtree: true})
	},
	beforeUnmount() {
		if(this.observer) this.observer.disconnect()
	}
}
</script>

<style scoped lang="scss">
	div {
		display: none;
	}
</style>